module.exports = __webpack_public_path__ + "static/img/ice@2x.14b32147.png";